import ZoomIn from "./ZoomIn";

export * from "./Accessibility01";
export * from "./CircleHelp";
export * from "./Contrast";
export * from "./Ear";
export * from "./EarOff";
export * from "./Eclipse";
export * from "./Eye";
export * from "./EyeOff";
export * from "./Glasses";
export * from "./Hand";
export * from "./Info";
export * from "./LifeBuoy";
export * from "./Moon";
export * from "./MoonStar";
export * from "./PersonStanding";
export * from "./Speech";
export * from "./Sun";
export * from "./SunDim";
export * from "./SunMedium";
export * from "./SunMoon";
export * from "./ZoomIn";
export * from "./ZoomOut";

export const Accessibili = {
  ZoomIn,
};
